import { CustomFieldFormData } from "@/formTypes/CustomFieldFormDataType";
import { GenericModelApi } from "./GenericModelApi";
import { ApiSchema } from "./ApiClient";
import { CustomFieldsTemplateIds } from "@pages/user/CustomFields";

export type CustomFieldDataType = Partial<ApiSchema["CustomField"]["type"] & CustomFieldFormData>;

class Api extends GenericModelApi<"CustomField", CustomFieldDataType> {

    async fetchByDocumentType(documentType: CustomFieldsTemplateIds): Promise<CustomFieldDataType> {
        const { items } = await this.fetchAll({ document_key: { eq: documentType } });
        return items.length ? items[0] : {};
    }
}

export const CustomFieldApi = new Api("CustomField", "document_key")